import { sentryFactory, useSentryMultiplex } from '@grantstreet/sentry'
import BaseSentry, { wrapSentryForProject } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'
export { useSentryMultiplexAsync } from '@grantstreet/sentry'

const dsns = {
  // Send checkout widget alerts to GH. (Treating it like GH mini)
  // govhub-ui-prod & -nonprod projects
  prod: 'https://10c054b10b974c81b73423a0d835e640@o168195.ingest.sentry.io/1432778',
  nonprod: 'https://0b277d98b53c4c4ab0748b2ede995898@o168195.ingest.sentry.io/5827657',
}

export const {
  sentryException: oldSentryException,
  vueErrorHandler,
  chainClient,
} = sentryFactory({ dsns })

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('cart-ui', {
  dsn: () => {
    // If the environment check throws an exception, we will default to logging
    // exceptions in prod, to ensure that we don't miss anything.
    let prod = true
    try {
      prod = isProd()
    }
    catch (error) {
      // If we're being initialized before isProd() works, we must be
      // about to send an event. Add a note to mention that we weren't
      // able to check isProd() in case it's relevant to the problem.
      BaseSentry.addBreadcrumb({
        message: 'Unable to check if prod. Defaulting to using prod Sentry DSN.',
        level: 'warning',
      })
    }

    return prod ? dsns.prod : dsns.nonprod
  },
})
export default Sentry

// This function is just a wrapper to pass the received arguments into the old
// or new sentry exception, based on the feature flag state. This will be a
// shortlived wrapper. This will be removed when the feature flag is removed,
// and the migration is completed.
export const sentryException = (...args) => useSentryMultiplex()
  // @ts-expect-error the args are just passed through to the correct handler
  ? Sentry.captureException(...args)
  // @ts-expect-error the args are just passed through to the correct handler
  : oldSentryException(...args)
